import store from "@/state/store";

export default [
  {
    path: "/",
    name: "dashboard",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/dashboard/dashboard"),
  },
  {
    path: "/map",
    name: "map",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator"],
    },
    component: () => import("../views/dashboard/map-window"),
  },

  // INCIDENT ROUTES
  {
    path: "/incident/incident-management",
    name: "incident",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/incident/incident.vue"),
  },
  {
    path: "/incident/accidents",
    name: "accidents",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/incident/accidents.vue"),
  },

  {
    path: "/incident/atcc-events",
    name: "atcc-events",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator"],
    },
    component: () => import("../views/incident/atcc-events.vue"),
  },
  {
    path: "/incident/vids-incidents",
    name: "vids-incidents",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/incident/vids.vue"),
  },
  {
    path: "/incident/vsds-incidents",
    name: "vsds-incidents",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/incident/vsds.vue"),
  },
  {
    path: "/incident/atcc-monitor",
    name: "atcc-monitor",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/incident/atcc.vue"),
  },
  {
    path: "/incident/all-incidents",
    name: "all-incidents",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/incident/all-incidents.vue"),
  },
  // {
  //   path: "/incident/raise-incident",
  //   name: "raise-incident",
  //   meta: {
  //     authRequired: true,
  //     rolesAllowed: ['superadmin', 'admin', 'rpo']
  //   },
  //   component: () => import("../views/incident/raise-incident.vue"),
  // },
  {
    path: "/incident/reports",
    name: "reports",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/incident/reports.vue"),
  },
  {
    path: "/incident/reports/incident-summary",
    name: "incident-summary",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../components/incidents/incident-summary.vue"),
  },
  {
    path: "/incident/view-incident-details/:incidentId",
    name: "view-incident-details",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/incident/view-incident-details.vue"),
    props: true,
  },
  {
    path: "/incident/view-atcc-details/:incidentId",
    name: "view-atcc-details",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator"],
    },
    component: () => import("../views/incident/view-atcc-details.vue"),
    props: true,
  },
  {
    path: "/incident/view-accident-details/:accidentId",
    name: "view-accident-details",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/incident/view-accident-details.vue"),
    props: true,
  },

  {
    path: "/incident/resolve-incidents/:incidentId",
    name: "resolve-incident",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/incident/resolve-incident.vue"),
    props: true,
  },

  {
    path: "/incident/resolve-accident/:accidentId",
    name: "resolve-accident",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/incident/resolve-accident.vue"),
    props: true,
  },

  // ADMINISTRATION ROUTES
  {
    path: "/administration/account-settings",
    name: "account-settings",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/administration/account-settings.vue"),
  },
  {
    path: "/administration/location-settings",
    name: "location-settings",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin"],
    },
    component: () => import("../views/administration/location-settings.vue"),
  },
  {
    path: "/administration/nms-management",
    name: "nms-management",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin"],
    },
    component: () => import("../views/administration/nms-management.vue"),
  },
  {
    path: "/administration/device-management",
    name: "device-management",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin"],
    },
    component: () => import("../views/administration/device-management.vue"),
  },
  {
    path: "/administration/package-management",
    name: "package-management",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin"],
    },
    component: () => import("../views/administration/package-management.vue"),
  },
  {
    path: "/administration/rpo-management",
    name: "rpo-management",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin"],
    },
    component: () => import("../views/administration/rpo-management.vue"),
  },
  {
    path: "/administration/company-management",
    name: "company-management",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin"],
    },
    component: () => import("../views/administration/company-management.vue"),
  },
  {
    path: "/administration/user-management",
    name: "user-management",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin"],
    },
    component: () => import("../views/administration/user-management.vue"),
  },
  {
    path: "/administration/api-management",
    name: "api-management",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin"],
    },
    component: () => import("../views/administration/api-management.vue"),
    props: true,
  },
  {
    path: "/administration/emergency-management",
    name: "emergency-management",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin"],
    },
    component: () => import("../views/administration/emergency-mgmt.vue"),
  },
  {
    path: "/administration/speed-limit-rules",
    name: "speed-limit-rules",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin"],
    },
    component: () => import("../views/administration/speed-limit-rules.vue"),
  },
  {
    path: "/administration/mqtt-management",
    name: "mqtt-management",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin"],
    },
    component: () => import("../views/administration/mqtt-management.vue"),
  },
  {
    path: "/administration/vms-device-management",
    name: "vids-device-management",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin"],
    },
    component: () =>
      import("../views/administration/vms-device-management.vue"),
  },
  {
    path: "/administration/vms-template-management",
    name: "vids-template-management",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin"],
    },
    component: () =>
      import("../views/administration/vms-template-management.vue"),
  },

  //  RPO ROUTES
  {
    path: "/rpo/dashboard",
    name: "rpo_dashboard",
    meta: {
      authRequired: true,
      rolesAllowed: ["rpo"],
    },
    component: () => import("../views/rpo/dashboard.vue"),
  },
  {
    path: "/incident/echallan",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/incident/echallan.vue"),
  },
  {
    path: "/management",
    name: "management",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/management/management.vue"),
  },
  {
    path: "/controller",
    name: "controller",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/controller/controller.vue"),
  },
  {
    path: "/devices/devicesList",
    name: "devices",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/devices/devicesList"),
  },
  // {
  //   path: "/routes/routes-list",
  //   name: "devices",
  //   meta: {
  //     authRequired: true,
  //     rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
  //   },
  //   component: () => import("../views/routes/routesList"),
  // },
  {
    path: "/rpo-details",
    name: "rpo-details",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
    },
    component: () => import("../views/incident/rpoDetailsForm.vue"),
  },

  // AUTH ROUTES
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "operator", "rpo", "emergency"],
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch("auth/logout");
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
        );
      },
    },
  },
  {
    path: "/404",
    name: "404",
    component: require("../views/utility/404").default,
  },
  {
    path: "*",
    redirect: "404",
  },
];
